import React from 'react';
import NavBar from "../NavBar";
import StatusBar from "../StatusBar";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

const Layout = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <NavBar />
      {isLoggedIn && !isHomePage && <StatusBar />}
      <main>{children}</main>
    </>
  );
};

export default Layout;